import React, {Component, Fragment} from 'react'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import ReactPlayer from 'react-player'

const SpaceOAR = () => {
    const { t } = useTranslation()
    const language = useSelector(state => state.language)
    const video = 'https://cdn.mannheim-urology.com/videos/SpaceOAR_Insertion.mp4'



const MyReactPlayer = () => {
  return (
    <div style={{ position: 'relative', width: '100%', height: '500px' }}>
      <ReactPlayer
        url="https://cdn.mannheim-urology.com/videos/SpaceOAR_Insertion.mp4"
        width="100%"
        height="100%"
        controls={true} startTime={7.0} playing={false}
        style={{ position: 'absolute', top: 0, left: 0 }} 
      />
    </div>
  );
};



    switch (language) {
        case 'EN':
            return (
                <section id="about1">
                    <div className="row">
 
                            <h2>SpaceOAR® Hydrogel for added protection</h2>
                            <hr/>
                            <p className="white">
                                SpaceOAR® Hydrogel is a temporary injectable gel that protects the rectum in men undergoing radiation therapy for prostate cancer, decreasing the likelihood of side effects. The SpaceOAR® System reduces rectal injury by acting as a spacer – pushing the rectum away from the prostate and out of the high dose radiation region.
                                <hr/>
                                <h2>How does SpaceOAR® Hydrogel work</h2>
                                The hydrogel spacer is injected during a minimally invasive procedure and once in place, patients typically can’t feel it. The hydrogel is safe and similar to other products used in brain surgery, cardiology and ophthalmology. It remains in place for three months during radiation treatment and is then absorbed and leaves the body in the patient’s urine — leaving nothing behind.
                                <hr/>
                                {/*Anatomy without SpaceOAR® Hydrogel. <br/> The rectum is next to the prostate complicating prostate radiation therapy.*/}
                                <h2>A Little Space Makes a BIG Difference™</h2>
                                Placed between the prostate and rectum, SpaceOAR hydrogel pushes the rectum out of the high dose radiation region. Like prostate cancer cells, cells in the rectum are also damaged by the high dose radiation. That’s why the rectum is called the Organ At Risk (OAR) during prostate radiation therapy.<br/>
                        <MyReactPlayer/>
                            </p>
 
                    </div>
                </section>
            )
        case 'RU':
            return (
                <section id="about1">
                    <div className="row">
                        <div className="nine columns main-col">
                            <h2>ProCure использует гидрогель SpaceOAR® для дополнительной защиты</h2>
                            <hr/>
                            <p className="white">
                                SpaceOAR® Hydrogel - это временный гель для инъекций, который защищает прямую кишку у мужчин, проходящих лучевую терапию по лечению рака простаты, снижая вероятность побочных эффектов. Система SpaceOAR® уменьшает травму прямой кишки, действуя как спейсер, отталкивая прямую кишку от простаты и из области высокой дозы излучения.
                                <hr/>
                                <h2>Как работает гидрогель SpaceOAR®</h2>
                                Спейсер из гидрогеля вводится во время минимально инвазивной процедуры, и после его установки пациенты обычно не чувствуют его. Гидрогель безопасен и аналогичен другим продуктам, используемым в хирургии головного мозга, кардиологии и офтальмологии. Он остается на месте в течение трех месяцев во время лучевой терапии, а затем абсорбируется и покидает тело с мочой пациента, не оставляя ничего.
                                <hr/>
                                {/*Anatomy without SpaceOAR® Hydrogel. <br/> The rectum is next to the prostate complicating prostate radiation therapy.*/}
                                <h2>Мало места - большая разница ™</h2>
                                омещенный между простатой и прямой кишкой, гидрогель SpaceOAR выталкивает прямую кишку из области высокой дозы радиации. Как и клетки рака простаты, клетки прямой кишки также повреждаются высокой дозой радиации. Вот почему во время лучевой терапии простаты прямую кишку называют органом риска (OAR).<br/>
                        <MyReactPlayer/>
                            </p>
                        </div>
                    </div>
                </section>
            )
        case 'BG':
            return (
                <section id="about1">
                    <div className="row">
                        <div className="nine columns main-col">
                            <h2>SpaceOAR® Hydrogel за допълнителна защита за минимизиране на потенциалните странични ефекти от лъчева терапия на рак на простатата</h2>
                            <hr/>
                            <p className="white">
                                Оптимизиране на качеството на живот, ако вие или ваш близък имате диагноза рак на простатата, може да обмислите лъчева терапия за лечение. Лъчевата терапия е изключително ефективна при лечение на рак на простатата, но както при всяка процедура има потенциални странични ефекти. Тези нежелани реакции могат да бъдат леки и да изчезнат сами, но за някои пациенти те могат да продължат години след приключване на лечението и могат да имат дълбоко отрицателно въздействие върху качеството на живот.
                                <hr/>
                                <h2>Нежеланите реакции могат да включват:</h2>
                                <ol>
                                    <li>Ректална болка и кървене</li>
                                    <li>Хронична диария</li>
                                    <li>Чести позиви за уриниране с отделяне на никаква или капки урина</li>
                                    <li>Уринарна инконтиненция</li>
                                    <li>Еректилна дисфункция</li>
                                </ol>
                                <hr/>
                                {/*Anatomy without SpaceOAR® Hydrogel. <br/> The rectum is next to the prostate complicating prostate radiation therapy.*/}
                                <h2>SpaceOAR® Hydrogel за допълнителна защита</h2>
                                SpaceOAR® Hydrogel е временен инжекционен гел, който предпазва ректума при мъже, подложени на лъчева терапия за рак на простатата, намалявайки вероятността от странични ефекти. Системата SpaceOAR® намалява ректалното увреждане, като действа като дистанционер - изтласквайки ректума от простатата и извън зоната на облъчване с високи дози.<br/>
                                <h2>Как действа SpaceOAR® Hydrogel</h2>
                                Хидрогелният дистанционер се инжектира по време на минимално инвазивна процедура и след като веднъж се постави на място, пациентите обикновено не могат да го усетят. Хидрогелът е безопасен и подобен на други продукти, използвани в мозъчната хирургия, кардиологията и офталмологията. Той остава на място в продължение на три месеца по време на лъчелечението и след това се абсорбира и оставя тялото в урината на пациента - без да оставя нищо след себе си.<br/>
                                <h2>Малкото пространство прави голяма разлика™</h2>
                                Разположен между простатата и ректума, SpaceOAR хидрогелът изтласква ректума от зоната с висока доза радиация. Подобно на раковите клетки на простатата, клетките в ректума също се увреждат от високата доза лъчение. Ето защо ректумът се нарича орган в риск (OAR) по време на лъчетерапия на простатата.<br/>
                        <MyReactPlayer/>
                            </p>
                        </div>
                    </div>
                </section>
            )
        default:
            return (
                <section id="about1">
                    <div className="row">
                        <div className="nine columns main-col">
                            <h2>SpaceOAR® Hydrogel for added protection</h2>
                            <hr/>
                            <p className="white">
                                SpaceOAR® Hydrogel is a temporary injectable gel that protects the rectum in men undergoing radiation therapy for prostate cancer, decreasing the likelihood of side effects. The SpaceOAR® System reduces rectal injury by acting as a spacer – pushing the rectum away from the prostate and out of the high dose radiation region.
                                <hr/>
                                <h2>How does SpaceOAR® Hydrogel work</h2>
                                The hydrogel spacer is injected during a minimally invasive procedure and once in place, patients typically can’t feel it. The hydrogel is safe and similar to other products used in brain surgery, cardiology and ophthalmology. It remains in place for three months during radiation treatment and is then absorbed and leaves the body in the patient’s urine — leaving nothing behind.
                                <hr/>
                                {/*Anatomy without SpaceOAR® Hydrogel. <br/> The rectum is next to the prostate complicating prostate radiation therapy.*/}
                                <h2>A Little Space Makes a BIG Difference™</h2>
                                Placed between the prostate and rectum, SpaceOAR hydrogel pushes the rectum out of the high dose radiation region. Like prostate cancer cells, cells in the rectum are also damaged by the high dose radiation. That’s why the rectum is called the Organ At Risk (OAR) during prostate radiation therapy.<br/>
                        <MyReactPlayer/>
                            </p>
                        </div>
                    </div>
                </section>
            )
    }
}

export default SpaceOAR



// WEBPACK FOOTER //
// ./src/Components/SpaceOAR.js